import styled, { css } from 'styled-components';
import transition from 'styled-transition-group';
import { default as DelCirBtn } from 'core/icons/DeleteCircleBtn';
import { default as DelXBtn } from 'core/icons/DeleteXBtn';
import { getColor } from 'core/utils';
import { slideOutToRight } from 'core/utils/KeyFrames';

export const ButtonWrapper = styled.div`
	padding: 0 5px;
	flex-basis: 86px;
	width: 86px;
`;

export const ShopBagItemContainer = transition.div`
	border-top: solid 0.5px ${getColor("alto")};
	padding: 12px 0;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: start;
	margin: 0;

	&:exit {
		animation: ${slideOutToRight} 0.5s ease-in-out 0s;
	}
	&:exit-active {
		opacity: 0;
	}

	${({ $multicart }) => $multicart && css`
		&:not(:nth-child(2)) {
			border-top: none;
		}
	`}
`;


export const ItemContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex-basis: calc(100% - 100px);
	margin: 0 -6px;
	width: 100%;
`;

export const ItemRow = transition.div`
	display: flex;
	width: 100%;

	&:not(:first-of-type) {
		margin-top: 16px;
	}
	&:exit {
		animation: ${slideOutToRight} 0.5s ease-in-out 0s;
	}
	&:exit-active {
		opacity: 0;
	}
`;


export const ItemImageContainer = styled.div`
	flex: 0 0 105px;
	overflow: hidden;
	padding-right: 6px;
	border-radius: 8px;
`;


export const ItemDescriptionContainer = styled.div`
	font-weight: 600;
	display: flex;
	flex-direction: column;
	padding: 0 6px;
	margin-right: auto;
`;


export const LinkStyle = styled.a`
	color: ${getColor("gray")};

	&:link, &:visited, &:hover, &:active {
		color: ${getColor("gray")};
		text-decoration: none;
	}
`;

export const CheckoutButtonStyle = styled.a`
	height: 30px;
	width: 86px;
	border: 2px solid ${getColor("primaryBrand")};
	color: ${getColor("gray")};
	font-weight: 600;
	background: #fff;
	align-self: center;
	border-radius: 4px;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 14px;

	&:hover {
		cursor: pointer;
	}
`;

export const DeleteItemStyle = styled.div`
	display: flex;
	align-items: center;
	margin-top: 8px;
	font-size: 12px;
	cursor: pointer;
	color: #9b9b9b;
	letter-spacing: 0.2px;
`;

export const Name = styled.span`
	/* stylelint-disable property-no-vendor-prefix, value-no-vendor-prefix */
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	/* stylelint-enable */

	font-size: 14px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	line-height: 18px;
	max-height: 38px;
	margin-right: 5px;

	@media (max-width: 425px) {
		word-break: break-word;
	}
`;

export const StoreName = styled(Name)`
	display: block;
	font-size: 16px;
	font-weight: 700;
	line-height: 30px;
`;

export const DeleteCircle = styled(DelCirBtn)`
	display: block;
	margin-right: 2px;
	margin-bottom: 2px;
`;

export const StoreContainer = styled.div`
	width: 100%;
	height: 30px;
	justify-content: space-between;
	display: flex;
	flex-direction: row;
	margin-bottom: 20px;
`;

export const RowColumn = styled.div`
	display: flex;
	flex-direction: column;
	height: auto;
	justify-content: space-between;
	align-items: flex-end;
`;

export const Image = styled.img`
	border-radius: 8px;
	max-width: inherit;
	width: 99px;
	height: 66px;
`;

export const DeleteX = styled(DelXBtn)`
	&:hover {
		cursor: pointer;
	}
`;

export const PlanDetails = styled.div`
	font-size: 12px;
	font-weight: 400;
	line-height: 15px;
	color: ${getColor("gray")};
`;
